module.exports = __webpack_public_path__ + "static/media/pin.8ac19237.svg";